import debug from "debug";

const httpDebugger = {
    error: debug("http:error"),
    request: debug("http:request"),
    response: debug("http:response")
};

export default httpDebugger;
